import React from "react";

const ResearchDisclaimer = () => (
  <div className="alert alert-info research-disclaimer" style={{ marginTop: "1rem" }}>
    Your anonymized information may be used for research and service improvement purposes. If you do not wish for your data to be used in this way, please email <a href="mailto:dpo@healthisone.co.uk">dpo@healthisone.co.uk</a>.
  </div>
);

export default ResearchDisclaimer;

